import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ComplianceFormQuestionGroup } from 'src/app/core/models/compliance-form.model';
import {
  MixpanelEventType,
  MixpanelService,
} from 'src/app/core/services/mixpanel-service/mixpanel.service';
import { selectLogoPathForEnrollmentBySubdomain } from 'src/app/core/store/enrollments/enrollments.selectors';
import { TravelersComplianceQuestionKeys } from '../../models/shared-compliance-form-questions';
import {
  CurrencyMaskOptions,
  EmperorUISelectFormChoice,
  PercentageMaskOptions,
} from '@boldpenguin/emperor-form-fields';

type TravelersFormGroup = {
  [key in TravelersComplianceQuestionKeys]: FormControl | FormArray;
};

@Component({
  selector: 'app-travelers-compliance-questions',
  templateUrl: './travelers-compliance-questions.component.html',
  styleUrl: './travelers-compliance-questions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelersComplianceQuestionsComponent implements OnInit {
  @Input() formGroup: FormGroup<TravelersFormGroup>;

  carrierLogo$: Observable<string>;
  readonly percentageMask = { ...PercentageMaskOptions, radix: '.' };
  readonly currencyMask = CurrencyMaskOptions;
  readonly TravelersComplianceQuestionKeys = TravelersComplianceQuestionKeys;
  readonly yesNoChoices: EmperorUISelectFormChoice[] = [
    {
      id: 'true',
      value: true,
      label: 'Yes',
    },
    {
      id: 'false',
      value: false,
      label: 'No',
    },
  ];

  constructor(
    private store: Store,
    private mixpanelService: MixpanelService,
  ) {}

  ngOnInit(): void {
    this.mixpanelService.track(
      MixpanelEventType.COMPLIANCE_TRAVELERS_QUESTIONS_LOADED,
    );
    this.carrierLogo$ = this.store.pipe(
      select(
        selectLogoPathForEnrollmentBySubdomain(
          ComplianceFormQuestionGroup.TRAVELERS,
        ),
      ),
    );
  }

  get topCarriersFormArray(): FormArray {
    return this.formGroup.get(
      TravelersComplianceQuestionKeys.TopCarriers,
    ) as FormArray;
  }

  get topIndustriesFormArray(): FormArray {
    return this.formGroup.get(
      TravelersComplianceQuestionKeys.TopIndustries,
    ) as FormArray;
  }
}
